import { formatChartDecimal } from "../util/chartFormat";
import { resolveActiveLocale } from "./sharmaReportMessages";

export function formatAllocationPercent(value) {
  return formatChartDecimal(value);
}

export function formatMainAllocationEmptyNotice(locale) {
  const loc = locale ?? resolveActiveLocale();
  if (loc === "es") {
    return "No hay posiciones de composición para este periodo. Puede elegir un subportafolio para continuar.";
  }
  return "There is no composition data for this period. You may select a sub-portfolio to continue.";
}

export function formatMainAllocationFetchNotice(locale, detail) {
  const loc = locale ?? resolveActiveLocale();
  const d = detail && String(detail).trim() ? String(detail).trim() : null;
  if (loc === "es") {
    return d
      ? `No se pudo cargar la composición (${d}). Puede elegir un subportafolio para continuar.`
      : "No se pudo cargar la composición. Puede elegir un subportafolio para continuar.";
  }
  return d
    ? `Composition could not be loaded (${d}). You may select a sub-portfolio to continue.`
    : "Composition could not be loaded. You may select a sub-portfolio to continue.";
}

export function formatMainAllocationReadyVoice(locale) {
  const loc = locale ?? resolveActiveLocale();
  if (loc === "es") {
    return "Aquí está la composición del portafolio principal.";
  }
  return "Here is the main portfolio composition.";
}
